export default __webpack_public_path__ + "static/media/leaf-bg-nft.8094404a.jpg";